import type { FaireProductEntity } from "../../entity_types/product";

export const p_f1oaqk8npf: FaireProductEntity = {
  token: "p_f1oaqk8npf",
  type: "product",
  name: "Joint Comfort Plant-Powered Lozenges™ with Turmeric, Ginger",
  brandToken: "b_dsnudsdke8",
  brandName: "Essential Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/657339a0f0c53c51021ead7485960d3f8dc6321051da587acf0cbfd0499914a1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/651691473ce821449e2e9003928531220d0b55da4b2793278211917e5380d5db.jpeg",
    "https://cdn.faire.com/fastly/649b3c23d50e5842920ba40201305471baa959d230378c9a4e0f3ec2a8b8e988.jpeg",
    "https://cdn.faire.com/fastly/04f020d0f4f743f98812d985d0a580d0a2084fff779bb32b6793eac67dc94a70.jpeg",
    "https://cdn.faire.com/fastly/a9ea49ce0b3f089b054508a4d6498e7211c42012e6588cfbcbaf23fd81d5a6d5.jpeg",
  ],
  priceDollars: 9.63,
  description:
    "Joint Comfort™ Plant-Powered Lozenges\n(formerly Complete Blend™)\nNow USDA Organic Certified, Gluten-Free Certified, Vegan Certified\n\nSupport mobility, flexibility, and daily wellness with our Joint Comfort Plant-Powered Lozenges™, thoughtfully crafted with six time-honored botanicals. Designed to promote joint comfort and ease occasional stiffness, this plant-powered blend transforms supportive herbs into a delicious, soothing lozenge.\n\n🍋 Lemon Zest – Packed with antioxidants that combat oxidative stress while adding bright, uplifting flavor.\n🌱 Spiced Ginger – Traditionally used to support joint comfort and soothe occasional inflammation.\n🌶️ Black Pepper – Contains piperine, which may enhance nutrient absorption and maximize the benefits of turmeric.\n🧡 Golden Turmeric – Curcumin-rich turmeric has long been valued for promoting mobility and reducing everyday discomfort.\n🌿 Burdock Root – A balancing herb with antioxidants that support overall wellness and detoxification.\n🌶️ Cayenne – Adds gentle warmth while encouraging circulation and joint flexibility.\n\nEach lozenge is made with organic, plant-based ingredients to deliver natural joint support in a tasty, convenient way. Perfect for those seeking to stay active, mobile, and supported throughout the day.",
  tags: [],
  msrpDollars: 19.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:43.309Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
